module.exports = __webpack_public_path__ + "img/beefbarr_0.e856fae3.jpg";